import {
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
  Avatar,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import {
  AccessTime,
  MedicalServices,
  Person,
  NotificationsActive,
  Login,
} from "@mui/icons-material";
import { COLORS, TIPO_COLOR, TIPO_LABEL, formatHora } from "./salaEsperaUtils";

export default function TicketCard({ ticket, onLlamar, llamando }) {
  const color = TIPO_COLOR[ticket.tipo] ?? COLORS.muted;

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: "0 4px 24px rgba(23,74,152,0.12)",
        background: "linear-gradient(135deg, #2196f3 0%, #174A98 100%)",
        color: "white",
        width: "100%",
        maxWidth: 680,
        mx: "auto",
        mb: 2,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Fila superior — número + tipo + botón llamar */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Typography
              variant="h2"
              fontWeight={700}
              sx={{ lineHeight: 1, color: "white" }}
            >
              {ticket.numero}
            </Typography>
            <Chip
              label={TIPO_LABEL[ticket.tipo] ?? ticket.tipo}
              size="small"
              sx={{
                background: "rgba(255,255,255,0.2)",
                color: "white",
                fontWeight: 600,
              }}
            />
          </Box>

          <Tooltip title="Llamar paciente">
            <span>
              <IconButton
                onClick={() => onLlamar(ticket.id)}
                disabled={llamando}
                sx={{
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  "&:hover": { background: "rgba(255,255,255,0.3)" },
                  gap: 1,
                  px: 2,
                  borderRadius: 2,
                }}
              >
                {llamando ? (
                  <CircularProgress size={18} sx={{ color: "white" }} />
                ) : (
                  <NotificationsActive />
                )}
                <Typography
                  variant="button"
                  sx={{ display: { xs: "none", sm: "block" } }}
                >
                  Llamar
                </Typography>
              </IconButton>
            </span>
          </Tooltip>
        </Box>

        {/* Fila paciente — foto + datos */}
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          {ticket.foto_url ? (
            <Avatar
              src={ticket.foto_url}
              sx={{
                width: 56,
                height: 56,
                border: "2px solid rgba(255,255,255,0.3)",
              }}
            />
          ) : (
            <Avatar
              sx={{
                width: 56,
                height: 56,
                background: "rgba(255,255,255,0.15)",
              }}
            >
              <Person sx={{ color: "rgba(255,255,255,0.7)" }} />
            </Avatar>
          )}
          <Box>
            {ticket.apellido ? (
              <Typography variant="h6" fontWeight={600}>
                {ticket.apellido} {ticket.nombres}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                sx={{ opacity: 0.6, fontStyle: "italic" }}
              >
                Paciente no encontrado en nuestros registros.
              </Typography>
            )}
            {ticket.tipo_documento && ticket.nro_documento && (
              <Typography variant="body2" sx={{ opacity: 0.75 }}>
                {ticket.tipo_documento} {ticket.nro_documento}
              </Typography>
            )}
            {ticket.prepaga_razon_social && (
              <Typography variant="caption" sx={{ opacity: 0.65 }}>
                {ticket.prepaga_codigo} · {ticket.prepaga_razon_social}
              </Typography>
            )}
          </Box>
        </Box>

        {/* Fila turno — especialidad + odontólogo + horarios */}
        {(ticket.especialidad ||
          ticket.hora_desde ||
          ticket.hora_ingreso_clinica) && (
          <Box
            sx={{
              background: "rgba(255,255,255,0.08)",
              borderRadius: 2,
              p: 1.5,
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {ticket.especialidad && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <MedicalServices sx={{ fontSize: 15, opacity: 0.7 }} />
                <Typography variant="caption" sx={{ opacity: 0.85 }}>
                  {ticket.especialidad}
                  {ticket.odontologo ? ` · ${ticket.odontologo}` : ""}
                </Typography>
              </Box>
            )}
            {ticket.hora_desde && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <AccessTime sx={{ fontSize: 15, opacity: 0.7 }} />
                <Typography variant="caption" sx={{ opacity: 0.85 }}>
                  Turno: {formatHora(ticket.hora_desde)}
                </Typography>
              </Box>
            )}
            {ticket.hora_ingreso_clinica && (
              <Box display="flex" alignItems="center" gap={0.5}>
                <Login sx={{ fontSize: 15, opacity: 0.7 }} />
                <Typography variant="caption" sx={{ opacity: 0.85 }}>
                  Ingreso: {ticket.hora_ingreso_clinica}
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
